"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.prettyPrintAllFormulas = exports.prettyPrintFormula = exports.isValidFormulaSyntax = exports.inspectDependencies = void 0;
const _ = __importStar(require("lodash"));
const formula_engine_1 = require("@finley-technologies/formula-engine");
var formula_engine_2 = require("@finley-technologies/formula-engine");
Object.defineProperty(exports, "inspectDependencies", { enumerable: true, get: function () { return formula_engine_2.inspectDependencies; } });
/**
 * checks given formula for syntax and function references.
 * @param formula
 * @returns {IsValid} type with validity, and errorMessages.
 *   This function only checks for the syntax and function references.
 *   It does not validate variables in the formula.
 */
const isValidFormulaSyntax = (formula) => {
    const { errorMessages } = (0, formula_engine_1.getFormulaErrors)(formula);
    return {
        isValid: errorMessages.length === 0,
        errorMessages,
    };
};
exports.isValidFormulaSyntax = isValidFormulaSyntax;
const prettyPrintFormula = (formula) => {
    return (0, formula_engine_1.prettyFormula)(formula);
};
exports.prettyPrintFormula = prettyPrintFormula;
/**
 * Prettifies any "formula" properties within the provided obj. Returns a transformed copy, does not edit in place.
 * @param obj Original object that has a "formula" property or nested property
 * @returns Obj
 */
const prettyPrintAllFormulas = (obj) => {
    const newObj = _.cloneDeep(obj);
    function prettyPrintTheFormulas(_obj) {
        for (const key in _obj) {
            if (Object.prototype.hasOwnProperty.call(_obj, key)) {
                if (key === 'formula' && _.isString(_obj[key])) {
                    const prettifiedFormula = (0, exports.prettyPrintFormula)(_obj[key]);
                    /* eslint-disable no-param-reassign */
                    _obj[key] = prettifiedFormula;
                }
                if (typeof _obj[key] === 'object' && _obj[key] !== null) {
                    prettyPrintTheFormulas(_obj[key]);
                }
            }
        }
    }
    prettyPrintTheFormulas(newObj);
    return newObj;
};
exports.prettyPrintAllFormulas = prettyPrintAllFormulas;
//# sourceMappingURL=formulaHelpers.js.map